import { useLayoutEffect, useState } from 'react';
import { fitDeviceScale, heightBudget } from './deviceScale';

/**
 * Measures the host slot and returns the scale the device should render at.
 * Height is measured, not assumed: what matters is how much viewport sits
 * below the frame's top edge, which depends on where the host page put it.
 */
export const useFitDeviceScale = (slotRef: React.RefObject<HTMLElement>) => {
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const slot = slotRef.current;
    if (!slot) return;

    const measure = () => {
      const rect = slot.getBoundingClientRect();
      setScale(
        fitDeviceScale({
          width: slot.clientWidth,
          height: heightBudget(rect.top, window.innerHeight),
        })
      );
    };

    measure();
    // The slot's own height is set from the scale, so the observer fires on
    // our own writes too; setScale ignores an unchanged value.
    const observer = new ResizeObserver(measure);
    observer.observe(slot);
    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [slotRef]);

  return scale;
};
